enum IncidentStatus {
  ACTIVE = 0,
  STANDBY = 1,
  ARCHIVED = 2,
}

export default IncidentStatus;
